import { login, logout } from '@/api/user'
import { getToken, setToken,  removeToken,removeCookie } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    nickName: '',
    orgId: ""//事务所的部门id
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // SET_EXPIRES_IN: (state, time) => {
    //   state.expires_in = time
    // },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ORGID: (state, orgId) => {
      state.orgId = orgId
    },
    SET_NICKNAME: (state, nickName) => {
      state.nickName = nickName
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          let data = res.data
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          removeCookie('orgInfo') 
          removeCookie('account') 
          removeCookie('selectFunc') 
          localStorage.removeItem('imgShowList')
          localStorage.removeItem('blankImageList')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user

